import router from "@/router"; // Adjust the path based on your project structure

// Use router.push() to navigate to a named route with parameters
export function $_viewEvent({ notification, callback }) {
  const status = (notification?.metaData?.deliveryStatus || '').toLowerCase();

  switch (status) {
    case "delivered":
      router.push("/historical-bookings");
      break;

      case "cancelled":
        router.push("/historical-bookings");
        break;

      case "accepted":
        router.push("/active-bookings");
        break;

      case "pending":
          router.push("/active-bookings");
          break;

      case "picked_up":
        router.push("/active-bookings");
        break;

      case "⁠⁠in-transit":
        router.push("/active-bookings");
        break;
  }
  callback && callback();
}
